import { render, staticRenderFns } from "./page.datacard.vue?vue&type=template&id=87abd760&scoped=true&"
import script from "./page.datacard.vue?vue&type=script&lang=js&"
export * from "./page.datacard.vue?vue&type=script&lang=js&"
import style0 from "./page.datacard.vue?vue&type=style&index=0&id=87abd760&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87abd760",
  null
  
)

export default component.exports